import { useFlags } from 'launchdarkly-react-client-sdk';
import { ENVIRONMENTS } from 'services/getEnvironmentalVariables';

export interface FeatureFlags {
    ldFlagLandDevelopment: boolean;
    ldFlagUploadedProForma: boolean;
    ldFlagNavbarV2: boolean;
    ldFlagVendorRevampQ22026: boolean;
}

const isDev = process.env.NODE_ENV === ENVIRONMENTS.DEV;

/*
    Dev-only testing w/o touching LD dashboard:
        localStorage.setItem('flagOverride:<flagName>', 'true'|'false')

    Clear all:
        Object.keys(localStorage)
            .filter(key => key.startsWith('flagOverride:'))
            .forEach(key => localStorage.removeItem(key));
*/
const getLocalOverride = (key: keyof FeatureFlags): boolean | undefined => {
    if (!isDev) return undefined;
    const stored = localStorage.getItem(`flagOverride:${key}`);
    return stored === null ? undefined : stored === 'true';
};

export const useTypedFlags = (): FeatureFlags => {
    const flags = useFlags<FeatureFlags>();

    if (!isDev) return flags;

    const overridden = { ...flags };

    (Object.keys(flags) as (keyof FeatureFlags)[]).forEach(key => {
        const override = getLocalOverride(key);
        if (override !== undefined) { 
            overridden[key] = override;
            console.log(`Overriding flag ${key} to ${override} (was ${flags[key]})`);
        }
    });

    return overridden;
};
